var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0.833333C8.33333 0.61232 8.24554 0.400358 8.08926 0.244078C7.93297 0.0877973 7.72101 0 7.5 0C7.27899 0 7.06702 0.0877973 6.91074 0.244078C6.75446 0.400358 6.66667 0.61232 6.66667 0.833333V6.66667H0.833333C0.61232 6.66667 0.400358 6.75446 0.244078 6.91074C0.0877973 7.06702 0 7.27899 0 7.5C0 7.72101 0.0877973 7.93297 0.244078 8.08926C0.400358 8.24554 0.61232 8.33333 0.833333 8.33333H6.66667V14.1667C6.66667 14.3877 6.75446 14.5996 6.91074 14.7559C7.06702 14.9122 7.27899 15 7.5 15C7.72101 15 7.93297 14.9122 8.08926 14.7559C8.24554 14.5996 8.33333 14.3877 8.33333 14.1667V8.33333H14.1667C14.3877 8.33333 14.5996 8.24554 14.7559 8.08926C14.9122 7.93297 15 7.72101 15 7.5C15 7.27899 14.9122 7.06702 14.7559 6.91074C14.5996 6.75446 14.3877 6.66667 14.1667 6.66667H8.33333V0.833333Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.65d85da8fd6fef0253ea809d5f253ba0.svg";
export { ForwardRef as ReactComponent };